<template>
  <!-- border-gradient-rainbow inherits its radius, so the wrapper sets it. -->
  <div v-if="notes.length > 0" class="rounded-lg" role="note">
    <!-- The accent gradient (#FFC75E → #F03DA2) the balance-migration box on
         this step uses, at a quieter scale: a note, not a call to action. -->
    <div class="border-gradient-rainbow flex items-start gap-3 p-4">
      <span
        class="flex size-7 shrink-0 items-center justify-center rounded-full bg-linear-to-br from-accent-gold to-accent-magenta text-onyx"
      >
        <fa-icon :icon="faInfo" class="size-3.5" aria-hidden="true" />
      </span>
      <div class="space-y-1 text-mouse">
        <p v-for="note in notes" :key="note">{{ note }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { faInfo } from '@fortawesome/pro-solid-svg-icons';

// The notes shown above the checkout's pay button for the current selection,
// in one box rather than one box each.
defineProps<{
  notes: string[];
}>();
</script>
